export default {"src":"/login-app/[GIT_HASH]/_next/static/media/create.65db9c50.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};